import { useComposedRefs } from "../../utils/use-composed-refs.js";
import { renderElement } from "../../utils/use-render.js";
import { usePopupPosition } from "./use-popup-position.js";
import { usePopoverContext } from "./context.js";
import { forwardRef, useCallback, useMemo, useRef } from "react";
//#region src/ui/popover/popup.tsx
/**
* Container for the popover content. Positioned relative to the trigger using CSS anchor positioning with a JavaScript
* fallback.
*/
const PopoverPopup = forwardRef(function PopoverPopup({ render, className, style, ...elementProps }, forwardedRef) {
	const { core, popover, state, preferredSide, setPositionedSide, stateAttrMap, anchorName, popupId, boundary, container } = usePopoverContext();
	const internalRef = useRef(null);
	const popupRef = useCallback((el) => {
		popover.setPopupElement(el);
	}, [popover]);
	const composedRef = useComposedRefs(forwardedRef, popupRef, internalRef);
	const posOpts = useMemo(() => ({
		side: preferredSide,
		align: state.align
	}), [preferredSide, state.align]);
	const positioningStyle = usePopupPosition({
		open: state.open,
		anchorName,
		position: posOpts,
		triggerSource: popover,
		popupRef: internalRef,
		boundary,
		container,
		onSideChange: setPositionedSide
	});
	if (!state.open) return null;
	const { onFocusOut, ...restPopupProps } = popover.popupProps;
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: composedRef,
		props: [
			{
				id: popupId,
				style: positioningStyle,
				...core.getPopupAttrs(state)
			},
			{
				...restPopupProps,
				onBlur: onFocusOut
			},
			elementProps
		]
	});
});
//#endregion
export { PopoverPopup };

//# sourceMappingURL=popup.js.map